import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
export type CompanyDealerDataFragment = (
  { __typename: 'Dealer' }
  & Pick<SchemaTypes.Dealer, 'id'>
  & { legalName: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ) }
);

export const CompanyDealerDataFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyDealerData on Dealer {
  id
  legalName {
    ...TranslatedStringData
  }
}
    `;